import * as PropTypes from "prop-types"
import styled from "styled-components"
import Icon from "components/icons/icon"
import { Info } from "components/icons/info"
import { color } from "helpers/styled"

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: ${color("skyBlue")}33;
  border-radius: 14px;

  > :first-child {
    flex: 0 0 auto;
  }
`

const Text = styled.p`
  margin: 0 0 0 15px;
  color: ${color("skyBlue")};
  font-size: 12px;
  line-height: 14px;
`

function InfoBanner({ children }) {
  return (
    <Wrapper>
      <Icon color="skyBlue" size="lg" Icon={Info} />
      <Text>{children}</Text>
    </Wrapper>
  )
}

InfoBanner.propTypes = {
  children: PropTypes.string.isRequired
}

export default InfoBanner
